import { useEffect } from 'react'
const drafts = new Set<symbol>()
let navigationConfirmed = false
export const confirmDraftNavigation = () => { navigationConfirmed = true }
export const hasUnsavedChanges = () => drafts.size > 0

export function useUnsavedChangesWarning(pending: boolean) {
  useEffect(() => {
    if (!pending) return
    navigationConfirmed = false
    const draft = Symbol('draft')
    drafts.add(draft)
    const warn = (event: BeforeUnloadEvent) => { if (!navigationConfirmed) { event.preventDefault(); event.returnValue = '' } }
    window.addEventListener('beforeunload', warn)
    return () => { drafts.delete(draft); window.removeEventListener('beforeunload', warn) }
  }, [pending])
}
